// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6f16a78","455":"889741de","977":"d2456b6a"}[chunkId] + ".chunk.js";
};